<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { useDetectDevice } from '@/composables/device'
import { EXPORT_FORMAT } from '@/composables/data-grid'

import RoiComparisonGrid from '@/components/roi/RoiComparisonGrid.vue'
import RoiComparisonFilterRow from '@/components/roi/RoiComparisonFilterRow.vue'

defineProps({
  comparison: {
    type: Object,
    required: true,
  },
})

const i18n = getI18n()
const { isMobile } = useDetectDevice()

const gridRef = ref(null)

const exportAsync = (format) => gridRef.value.exportAsync(format)
</script>

<template>
  <div class="relative-position" :class="{ 'col column no-wrap': isMobile }">
    <div class="row items-center no-wrap q-py-xs" :class="{ 'q-px-md': isMobile }">
      <roi-comparison-filter-row class="col" :comparison="comparison" />
      <q-btn
        flat
        round
        size="sm"
        icon="mdi-download"
        class="q-ml-sm"
      >
        <q-tooltip>{{ i18n.t('common.export') }}</q-tooltip>
        <q-menu auto-close>
          <q-list dense style="min-width: 12rem;">
            <q-item clickable @click="exportAsync(EXPORT_FORMAT.XLSX)">
              <q-item-section avatar><q-icon name="mdi-microsoft-excel" size="xs" /></q-item-section>
              <q-item-section>{{ i18n.t('common.exportExcel') }}</q-item-section>
            </q-item>
            <q-item clickable @click="exportAsync(EXPORT_FORMAT.PDF)">
              <q-item-section avatar><q-icon name="mdi-printer" size="xs" /></q-item-section>
              <q-item-section>{{ i18n.t('roiCompare.exportPdf') }}</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>
    <q-inner-loading :showing="comparison.loading" />
    <div :class="{ 'col relative-position': isMobile }">
      <roi-comparison-grid ref="gridRef" :comparison="comparison" :class="{ 'absolute-full': isMobile }" />
    </div>
  </div>
</template>
